import { render, staticRenderFns } from "./BranchRoleEdit.vue?vue&type=template&id=5ba3429a&scoped=true&"
import script from "./BranchRoleEdit.vue?vue&type=script&lang=js&"
export * from "./BranchRoleEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ba3429a",
  null
  
)

export default component.exports